module.exports = __webpack_public_path__ + "img/roofs.19ad46f2.jpg";